import footGuide from './footer'
import headGuide from './header'
import subtitleGuide from  './subtitle'
import Echart from './echart'
import asideMenu from './asideMenu'
import asideItem from './asideItem'
import generalContainer from './generalContainer'
import popBox from './popBox'
import filterBox from './filterBox'
import VerticalTable from './verticalTable'

export default {
  'foot-guide':footGuide,
  'head-guide':headGuide,
  'subtitle-guide':subtitleGuide,
  'v-echart':Echart,
  'aside-menu':asideMenu,
  'aside-item':asideItem,
  'general-container':generalContainer,
  'pop-box':popBox,
  'filter-box':filterBox,
  'vertical-table':VerticalTable
}



// WEBPACK FOOTER //
// ./src/components/basics/index.js